
<div class="row" style="min-height: 110px; padding-top: 10px;">
	<div class="col col-4"><div style="position: relative; top: 30px"><span i18n="Common|Frames">Frames</span>:</div></div>
	<div class="col col-8">
		<div style="width: 95px;">
			<button class="out" kendoButton [selected]="current.topFrame?.visible" [toggleable]="true" (selectedChange)="change(current.topFrame)"
				[disabled]="!isEnabled('Top')" style="left: 30px;"></button>
			<br>
			<button class="out" kendoButton [selected]="current.leftFrame?.visible" [toggleable]="true" (selectedChange)="change(current.leftFrame)"
				[disabled]="!isEnabled('Left')" style="left: 0px;"></button>
			<button class="out" kendoButton [selected]="current.rightFrame?.visible" [toggleable]="true" (selectedChange)="change(current.rightFrame)"
				[disabled]="!isEnabled('Right')" style="left: 30px;"></button>
			<br>
			<button class="out" kendoButton [selected]="current.bottomFrame?.visible" [toggleable]="true" (selectedChange)="change(current.bottomFrame)"
				[disabled]="!isEnabled('Bottom')" style="left: 30px;"></button>
		</div>
	</div>
</div>


<div *ngIf="projectService.showDebugInfo" class="testMode">

	<div class="col col-8">
		<div style="width: 95px;">
			{{ current.topFrame?.mode }} 
			<br>
			{{ current.leftFrame?.mode }} &nbsp; {{ current.rightFrame?.mode }}
			<br>
			{{ current.bottomFrame?.mode }}
		</div>
	</div>

</div>

